<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark custom-navbar"
    :class="{ 'navbar-demo-mode': isDemoMode, 'navbar-demo-hidden': isNavbarHidden }"
    aria-label="Offcanvas navbar large"
  >
    <div class="container-fluid">
      <!-- Logo en modo demo - SOLO cuando navbar está oculta -->
      <div v-if="isDemoMode && isNavbarHidden" class="navbar-demo-logo" @click="toggleNavbarDemo">
        <img
          src="../assets/images/Logo.png"
          width="35"
          height="35"
          alt="Logo"
          class="demo-logo-img"
        />
      </div>

      <!-- Contenido principal - Siempre visible excepto en demo oculto -->
      <div v-if="!isDemoMode || (isDemoMode && !isNavbarHidden)" class="navbar-main-content">
        <!-- Logo y brand -->
        <div class="navbar-brand-section">
          <div class="navbar-logo-container" @click="handleLogoClick">
            <img
              src="../assets/images/Logo.png"
              width="35"
              height="35"
              alt="Desarrollo web profesional y creación de sitios modernos"
            />
          </div>
          <a class="navbar-brand" href="#">
            Leonar2
          </a>
        </div>

        <!-- Botones de navegación - SOLO en desktop y NO en demo móvil -->
        <div v-if="shouldShowNavButtons" class="navbar-buttons">
          <div class="nav-buttons-container">
            <Router-link
              class="nav-button"
              :class="{ active: activeLink === 'inicio' }"
              to="/"
              @click="setActiveLink('inicio')"
            >
              Inicio
            </Router-link>

            <Router-link
              class="nav-button"
              :class="{ active: activeLink === 'servicios' }"
              to="/Servicios"
              @click="setActiveLink('servicios')"
            >
              Servicios
            </Router-link>

            <div class="nav-dropdown">
              <button class="nav-button menu-button">
                Menu
              </button>
              <div class="dropdown-content">
                <Router-link
                  to="/Yo"
                  class="dropdown-item"
                  :class="{ active: activeLink === 'acerca' }"
                  @click="setActiveLink('acerca')"
                >
                  Acerca de Mí
                </Router-link>
                <Router-link
                  to="/Contacto"
                  class="dropdown-item"
                  :class="{ active: activeLink === 'contacto' }"
                  @click="setActiveLink('contacto')"
                >
                  Contacto
                </Router-link>
                <div class="dropdown-divider"></div>
                <Router-link
                  to="/Ejemplos"
                  class="dropdown-item"
                  :class="{ active: activeLink === 'ejemplos' }"
                  @click="setActiveLink('ejemplos')"
                >
                  Ejemplos
                </Router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Botón hamburguesa SOLO en móvil y modo normal -->
        <button
          v-if="showHamburger"
          class="navbar-toggler custom-toggler"
          :class="{ 'custom-toggler-inactive': isOffcanvasOpen }"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar2"
          aria-controls="offcanvasNavbar2"
          aria-label="Toggle navigation"
          ref="togglerButton"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>

      <!-- Offcanvas SOLO en modo normal (NO en demo) -->
      <div
        v-if="!isDemoMode"
        class="offcanvas offcanvas-end custom-offcanvas"
        tabindex="-1"
        id="offcanvasNavbar2"
        aria-labelledby="offcanvasNavbar2Label"
        @show.bs.offcanvas="onOffcanvasShow"
        @hidden.bs.offcanvas="onOffcanvasHide"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasNavbar2Label">Menú</h5>
          <button
            type="button"
            class="btn-close btn-close-white custom-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            @click="forceTogglerInactive"
          >
          </button>
        </div>
        <div class="offcanvas-body">
          <div class="mobile-nav-buttons">
            <Router-link
              class="mobile-nav-button"
              :class="{ active: activeLink === 'inicio' }"
              to="/"
              @click="closeOffcanvasAndSetActive('inicio')"
            >
              Inicio
            </Router-link>

            <Router-link
              class="mobile-nav-button"
              :class="{ active: activeLink === 'servicios' }"
              to="/Servicios"
              @click="closeOffcanvasAndSetActive('servicios')"
            >
              Servicios
            </Router-link>

            <Router-link
              class="mobile-nav-button"
              :class="{ active: activeLink === 'acerca' }"
              to="/Yo"
              @click="closeOffcanvasAndSetActive('acerca')"
            >
              Acerca de Mí
            </Router-link>

            <Router-link
              class="mobile-nav-button"
              :class="{ active: activeLink === 'contacto' }"
              to="/Contacto"
              @click="closeOffcanvasAndSetActive('contacto')"
            >
              Contacto
            </Router-link>

            <Router-link
              class="mobile-nav-button"
              :class="{ active: activeLink === 'ejemplos' }"
              to="/Ejemplos"
              @click="closeOffcanvasAndSetActive('ejemplos')"
            >
              Ejemplos
            </Router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
/* eslint-disable */
export default {
  name: 'NavbarComponent',
  data () {
    return {
      activeLink: 'inicio',
      isOffcanvasOpen: false,
      isDemoMode: false,
      isNavbarHidden: true,
      isMobileView: false
    };
  },

  computed: {
    shouldShowNavButtons () {
      return !this.isMobileView && (!this.isDemoMode || (this.isDemoMode && !this.isNavbarHidden));
    },

    showHamburger () {
      return this.isMobileView && !this.isDemoMode;
    }
  },

  mounted () {
    this.detectCurrentRoute();
    this.setupDemoModeListener();
    this.setupTogglerObserver();
    this.checkMobileView();
    window.addEventListener('resize', this.checkMobileView);

    this.$router.afterEach(() => {
      this.detectCurrentRoute();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.closeOffcanvas();
      this.forceTogglerInactive();
    });
  },

  beforeUnmount () {
    window.removeEventListener('resize', this.checkMobileView);
  },

  methods: {
    checkMobileView () {
      this.isMobileView = window.innerWidth < 992;
    },

    setupDemoModeListener () {
      window.addEventListener('activate-demo-mode', (event) => {
        this.activateDemoMode(event.detail.projectId);
      });

      window.addEventListener('deactivate-demo-mode', () => {
        this.deactivateDemoMode();
      });
    },

    activateDemoMode (projectId) {
      console.log('🔄 NAVBAR: Activando modo demo');
      this.isDemoMode = true;
      this.isNavbarHidden = true;
      this.activeLink = 'ejemplos';

      window.dispatchEvent(new CustomEvent('demo-controls-visibility', {
        detail: { showControls: false }
      }));

      window.dispatchEvent(new CustomEvent('load-demo-manager', {
        detail: { projectId }
      }));
    },

    deactivateDemoMode () {
      console.log('🔄 NAVBAR: Desactivando modo demo');
      this.isDemoMode = false;
      this.isNavbarHidden = false;
      this.detectCurrentRoute();

      window.dispatchEvent(new CustomEvent('demo-controls-visibility', {
        detail: { showControls: false }
      }));
    },

    toggleNavbarDemo () {
      this.isNavbarHidden = !this.isNavbarHidden;
      console.log('🔘 NAVBAR Demo:', this.isNavbarHidden ? 'Oculto' : 'Visible');

      window.dispatchEvent(new CustomEvent('demo-controls-visibility', {
        detail: { showControls: !this.isNavbarHidden }
      }));
    },

    setActiveLink (link) {
      this.activeLink = link;
    },

    closeOffcanvasAndSetActive (link) {
      this.setActiveLink(link);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.closeOffcanvas();
      this.forceTogglerInactive();
    },

    detectCurrentRoute () {
      const route = this.$route.path;
      const routeMap = {
        '/': 'inicio',
        '/Servicios': 'servicios',
        '/Yo': 'acerca',
        '/Contacto': 'contacto',
        '/Ejemplos': 'ejemplos',
        '/demos/modo-claro-oscuro': 'ejemplos',
        '/Demo_ClaroOscuro': 'ejemplos'
      };
      this.activeLink = routeMap[route] || 'inicio';
    },

    closeOffcanvas () {
      const offcanvas = document.getElementById('offcanvasNavbar2');
      if (offcanvas) {
        const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
    },

    setupTogglerObserver () {
      const toggler = this.$refs.togglerButton;
      if (toggler) {
        this.forceTogglerInactive();
      }
    },

    forceTogglerInactive () {
      const toggler = this.$refs.togglerButton;
      if (toggler) {
        toggler.classList.remove('show');
        toggler.classList.remove('collapsed');
        toggler.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
          toggler.classList.remove('show');
          toggler.classList.remove('collapsed');
          toggler.setAttribute('aria-expanded', 'false');
        }, 100);
      }
      this.isOffcanvasOpen = false;
    },

    onOffcanvasShow () {
      this.isOffcanvasOpen = true;
    },

    onOffcanvasHide () {
      this.isOffcanvasOpen = false;
      this.forceTogglerInactive();
    },

    handleLogoClick () {
      if (this.isDemoMode) {
        this.toggleNavbarDemo();
      }
    }
  }
};
</script>

<style scoped>
/* ESTILOS BASE */
.custom-navbar {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  width: 100%;
  background-color: var(--color-surface) !important;
  padding: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid var(--color-background);
  transition: all 0.3s ease;
}

.container-fluid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0px !important;
  padding-right: 1rem;
}

/* CONTENIDO PRINCIPAL */
.navbar-main-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* LOGO Y BRAND */
.navbar-brand-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.navbar-logo-container {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.navbar-brand {
  color: var(--color-text-primary) !important;
  font-weight: 600;
  font-size: 1.2rem;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  text-decoration: none;
}

/* ELIMINAR OUTLINE AZUL FEOS EN TODOS LOS ELEMENTOS */
.navbar-brand:focus,
.navbar-brand:active,
.nav-button:focus,
.nav-button:active,
.menu-button:focus,
.menu-button:active,
.dropdown-item:focus,
.dropdown-item:active,
.mobile-nav-button:focus,
.mobile-nav-button:active,
.custom-toggler:focus,
.custom-toggler:active {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

/* BOTONES DE NAVEGACIÓN PERSONALIZADOS */
.navbar-buttons {
  display: flex;
  align-items: center;
}

.nav-buttons-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-button {
  color: var(--color-text-secondary) !important;
  padding: 0.5rem 1rem !important;
  text-decoration: none;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  font-size: 1rem;
  white-space: nowrap;
  /* ELIMINAR OUTLINE COMPLETAMENTE */
  outline: none !important;
  box-shadow: none !important;
}

.nav-button:hover {
  color: var(--color-text-primary) !important;
  border-bottom: 3px solid rgba(92, 141, 246, 0.3);
}

.nav-button.active {
  color: var(--color-primary) !important;
  border-bottom: 3px solid var(--color-primary) !important;
  font-weight: 600;
}

/* BOTÓN MENÚ SIN TRIANGULO */
.menu-button {
  /* Sin triangulo - solo el texto "Menu" */
  position: relative;
}

/* DROPDOWN PERSONALIZADO */
.nav-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  background-color: var(--color-surface);
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  padding: 0.5rem 0;
  z-index: 1000;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-dropdown:hover .dropdown-content {
  display: block;
}

.dropdown-item {
  display: block;
  padding: 0.75rem 1rem;
  text-decoration: none;
  color: var(--color-text-secondary);
  transition: all 0.2s ease;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  cursor: pointer;
  /* ELIMINAR OUTLINE */
  outline: none !important;
  box-shadow: none !important;
}

.dropdown-item:hover {
  color: var(--color-text-primary);
  background-color: rgba(92, 141, 246, 0.15) !important;
  border-left: 3px solid var(--color-primary);
}

.dropdown-item.active {
  background-color: rgba(92, 141, 246, 0.15);
  color: var(--color-primary);
  border-left: 3px solid var(--color-primary);
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0.25rem 0;
}

/* BOTONES MÓVIL */
.mobile-nav-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mobile-nav-button {
  display: block;
  padding: 1rem;
  text-decoration: none;
  color: var(--color-text-secondary);
  border-radius: 8px;
  transition: all 0.3s ease;
  border: none;
  background: transparent;
  text-align: left;
  width: 100%;
  /* ELIMINAR OUTLINE */
  outline: none !important;
  box-shadow: none !important;
}

.mobile-nav-button:hover,
.mobile-nav-button.active {
  background-color: rgba(92, 141, 246, 0.15);
  color: var(--color-primary);
}

/* MODO DEMO */
.navbar-demo-mode.navbar-demo-hidden {
  background-color: transparent !important;
  box-shadow: none !important;
  border-bottom: none !important;
}

.navbar-demo-mode.navbar-demo-hidden .navbar-main-content {
  display: none !important;
}

.navbar-demo-logo {
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1070;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.navbar-demo-logo:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: scale(1.05);
}

.demo-logo-img {
  border-radius: 8px;
}

.navbar-demo-mode:not(.navbar-demo-hidden) .navbar-demo-logo {
  display: none !important;
}

.navbar-demo-mode:not(.navbar-demo-hidden) .navbar-main-content {
  display: flex !important;
}

/* BOTÓN HAMBURGUESA - ELIMINAR OUTLINE AZUL */
.custom-toggler {
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  transition: all 0.3s ease;
  /* ELIMINAR OUTLINE AZUL */
  outline: none !important;
  box-shadow: none !important;
}

.custom-toggler:focus,
.custom-toggler:active,
.custom-toggler:hover {
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  background-color: transparent !important;
}

.custom-toggler-inactive {
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  opacity: 0.5;
  background-color: transparent !important;
}

/* OFFCANVAS */
.custom-offcanvas {
  background-color: var(--color-surface) !important;
  color: var(--color-text-primary);
}

.custom-close {
  filter: invert(1) !important;
  opacity: 1 !important;
  margin: 0 !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Responsive */
@media (max-width: 991px) {
  .navbar-brand {
    font-size: 1.1rem;
  }

  .navbar-demo-logo {
    top: 12px;
    left: 12px;
    padding: 6px;
  }

  /* Ocultar botones desktop en móvil */
  .navbar-buttons {
    display: none !important;
  }
}

@media (min-width: 992px) {
  /* Ocultar botones móviles en desktop */
  .mobile-nav-buttons {
    display: none !important;
  }
}
</style>
